export default theme => ({
    
    squareUptime: {
        color: "#41B900",
        width:"32px",
        height:"32px"
    },
    squareDowntime: {
        color: '#C2272D',
        width:"32px",
        height:"32px"
    },
    squareParcial: {
        color: "#FFC600",
        width:"32px",
        height:"32px"
    },
    tableCell:{
        padding:"0px 0px 0px 0px",
        textAlign:"center",
        borderBottom: "none"
    },
    td:{
        padding:"0px 0px 0px 0px",
        borderTop: "0px solid #e4dede",
        borderBottom: "0px ",
        width:"4.5%",
      },
    tableCellCargando:{
        width:"1%",
        padding:"4px 0px 4px 4px",
        borderTop: "0px solid #e4dede",
        borderBottom: "4px solid #e4dede"

    },
    shape: {
        backgroundColor: theme.palette.uptime.default,
        width: 24,
        height: 14,
        borderRadius: '15%',
      },
    shapeDowntime: {
        backgroundColor: theme.palette.downtime.default,
        width: 24,
        height: 14,
        borderRadius: '15%',
      },
    shapeParcial: {
        backgroundColor: theme.palette.parcial.default,
        width: 24,
        height: 14,
        borderRadius: '15%',
      },
    shapeNoMon: {
        backgroundColor: theme.palette.noMon.default,
        width: 24,
        height: 14,
        borderRadius: '15%',
    },
  });
  
  